import {ComponentProps, Fragment, useEffect, useState} from "react";
import {useForm, useWatch} from "antd/lib/form/Form";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    Space,
    Switch,
    Table,
    Select as AntSelect,
    message, Popconfirm, Checkbox, UploadFile, Radio, TooltipProps, Modal, Tooltip
} from "antd";
import DictSelect from "../../components/DictSelect";
import {RouteComponentProps, useParams} from "react-router";
import DatePicker from "../../components/DatePicker";
import styles from "./index.module.css";
import Upload from "../../components/Upload";
import Select from "../../components/Select";
import {ColumnProps} from "antd/lib/table";
import * as api from "../../apis/platforms/admin/contract";
import * as productApi from "../../apis/product";
import * as suitApi from "../../apis/suit";
import * as giveawayApi from "../../apis/productGiveaway";
import * as dealerApi from "../../apis/dealer";
import * as hospitalApi from "../../apis/platforms/admin/hospital";
import * as instrumentApi from "../../apis/platforms/admin/placingInstruments";

import {useRequest} from "ahooks";
import ProductSelectModal from "../../components/ProductSelectModal";
import GiveawayRulesModal from "../../components/GiveawayRulesModal";
import {NamePath} from "antd/lib/form/interface";
import {Option} from "antd/lib/mentions";
import {Link, useHistory} from "react-router-dom";
import * as minIoUtils from "../../utils/minio";
import * as utils from "../../utils/utils";
import dayjs from "dayjs";
import {ContractStatusMapping, PlatformType} from "../../utils/constants";
import {getInstrumentsByHospital} from "../../apis/platforms/admin/placingInstruments";
import BaseDataSelect from "../../components/BaseDataSelect";
import ExistContractsModal from "./components/ExistContractsModal";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {getDealer, getDealerList} from "../../apis/dealer";
import withAuth from "../../utils/withAuth";
import UploadModal from "../../components/UploadModal";
import {getSuitWithGiveaways} from "../../apis/suit";
import useAuth from "../../utils/useAuth";
import {Decimal} from "decimal.js";


type RouteParam = {
    id?: string,
}


const enum Mode {
    Create, Modify, Detail, Revision, Version,
}

// const FormValue = (props: any) => props.value;
const FormValueColumn = (dataIndex: string, title: string, width: number = 100, fixed?: 'left' | 'right') => (
    {
        dataIndex,
        title,
        key: dataIndex,
        width,
        fixed,
        // render(v: any, r: any, index: number) {
        //     return (<Form.Item name={[index, dataIndex]}><FormValue/></Form.Item>)
        // }
    }
);

const RevisionFieldsMap: { [key: string]: Array<string> } = {
    'payment-form': [
        'paymentForm', 'accountingPeriod', 'attachment'
    ],
    'transform': [
        'transportMethod', 'transportFreeTimes', 'transportFullCredit', 'attachment'
    ],
    'product': [
        'suit', 'products', 'importProduct', 'importGiveaways', 'attachment'
    ],
    'other': [
        'invoiceGiveaway', 'startDate', 'endDate', 'remark', 'attachment'
    ],
}


const EditButton = withAuth('edit', Button);
const RevisionButton = withAuth('revision', Button);
const DeletePopconfirm = withAuth('delete', Popconfirm);
const ToOAButton = withAuth('toOA', Button);
const AcceptFragment = withAuth('accept', Fragment);
const RejectFragment = withAuth('reject', Fragment);
const ImportProductButton = withAuth('importProduct', Button);
const ImportGiveawaysButton = withAuth('importGiveaways', Button);

function ContractEdit(props: RouteComponentProps<RouteParam>) {
    const {id} = useParams<RouteParam>();
    const history = useHistory();
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform;
    const isVersionId = history.location.pathname.indexOf('version') > 0;
    const [form] = useForm();
    const [mode, setMode] = useState<Mode>();
    const [productOptions, setProductOptions] = useState<Array<any>>([]);
    const [suitOptions, setSuitOptions] = useState<Array<any>>([]);
    const [selectedSuit, setSelectedSuit] = useState<number>();
    const [productModalVisible, setProductModalVisible] = useState(false);
    const [giveawaysModalVisible, setGiveawaysModalVisible] = useState(false);
    const [importProductModalVisible, setImportProductModalVisible] = useState(false);
    const [importGiveawaysModalVisible, setImportGiveawaysModalVisible] = useState(false);
    const [giveawaysNamePath, setGiveawaysNamePath] = useState<NamePath>();
    const [versions, setVersions] = useState([]);
    const [currentVersion, setCurrentVersion] = useState<any>({});
    const [instrumentsOption, setInstrumentsOption] = useState<Array<any>>([]);
    const [hospitalsOption, setHospitalOption] = useState<Array<any>>([]);
    const products: Array<any> | undefined = useWatch('products', form);
    const isTerminal: boolean = useWatch('isTerminal', form);
    const hospitalId: number = useWatch('hospitalId', form);
    const dealerId: number = useWatch('dealerId', form);
    const groupId: number = useWatch('groupId', form);
    const paymentForm: string | undefined = useWatch('paymentForm', form);
    const contractType: string | undefined = useWatch('contractType', form);
    const revisionType = useWatch('type', form);
    const purchaseRestrict = useWatch('purchaseRestrict', form);
    const [revisionEnableFields, setRevisionEnableFields] = useState<Array<any>>([]);
    const [forceDisabled, setForceDisabled] = useState(false);
    const [existContracts, setExistContracts] = useState<Array<any>>([]);
    const [existContractsModalVisible, setExistContractsModalVisible] = useState(false);
    // const [dealer, setDealer] = useState<any>({});
    const enableModifyGiveaways = useAuth().indexOf('editGiveaways') > -1;

    const [isApproving, setIsApproving] = useState<boolean>(false);

    useEffect(() => {
        setForceDisabled(mode === Mode.Detail || mode === Mode.Version)
    }, [mode]);
    useEffect(() => {
        refreshSuitDisabled();
        refreshProductDisabled();
        products?.forEach((p, i) => p?.suitId && handleProductPriceChange(p?.price, p, i))
    }, [products]);

    useEffect(() => {
        runGetData();
    }, [id]);

    useEffect(() => {
        if (!hospitalId && !dealerId) {
            setInstrumentsOption([]);
        } else {
            getInstruments(hospitalId, dealerId);
        }
    }, [hospitalId, dealerId]);

    useEffect(() => {
        if (!dealerId) {
            setHospitalOption([]);
        } else {
            getHospitals(dealerId);
        }
    }, [dealerId]);

    useEffect(() => {
        if (!groupId && !dealerId) {
            setExistContracts([]);
        } else {
            getExistContract({groupId, dealerId});
        }
    }, [groupId, dealerId]);
    useEffect(() => {
        setRevisionEnableFields(RevisionFieldsMap[revisionType] || []);
    }, [revisionType]);

    const doSuitAppend = async () => {
        if (!selectedSuit) {
            message.error('请选择套餐');
            return;
        }
        const suitProducts = form.getFieldValue('products') || [];
        const suitRes = await suitApi.getSuitWithGiveaways(selectedSuit);
        const suit = suitRes.data.data;
        suit.products.forEach((p: any) => {
            p.id = undefined;
            p.productCategoryName = !!p.categoryName ? p.categoryName.replaceAll('//', '/').split('/')?.[1] : undefined;
            p.productQuote = p?.productQuote || 0;
            p.price = p?.price || 0;
            p.suitPrice = suit.products?.filter((s: any) => s.suitId == p.suitId).map((item: any) => new Decimal(item.price ?? 0).mul(item.qty ?? 0)).reduce((amount1: Decimal, amount2: Decimal) => amount1.add(amount2), new Decimal(0)).toNumber()
            p.expiration = 6;
            // p.enableGiveaway = !!p.giveaways?.length; //2024-11-04 改为默认勾选
            p.enableGiveaway = true;
            p.giveaways = [];//forEach((g:any)=>g.id=undefined);
            p.restrictQty = null;
            suitProducts.push(p);
            console.log(p)
        });
        // debugger
        form.setFieldValue('products', [...suitProducts].filter(p => !!p.productId));
    }

    const doGiveawaysAppend = async (index: number) => {
        const product = (products || [])[index];
        if (product.giveaways?.length) {
            return;
        }
        const giveawaysRes = await giveawayApi.getGiveawayRulesByProductId(product.productId);
        const giveaways = giveawaysRes?.data?.data;
        giveaways.forEach((g: any) => g.id = undefined);
        if (Array.isArray(giveaways)) {
            form.setFieldValue(['products', index, 'giveaways'], giveaways)
        }
    }

    const getData = async () => {
        if (!id) {
            setMode(Mode.Create);
            return;
        }
        if (!isVersionId) {
            const response = await api.getContractById(parseInt(id!!));
            const contract = response.data.data;
            const versionsResponse = await api.getContractVersions(contract.id);
            const vers = versionsResponse.data.data || [];
            setVersions(vers);
            const curVer = vers.find((v: any) => v.id === contract.versionId);
            setCurrentVersion(curVer)
            form.setFieldsValue(contract);
        } else {
            const versionResponse = await api.getContractVersion(parseInt(id!!));
            const contract = versionResponse.data.data;
            const versionsResponse = await api.getContractVersions(contract.id);
            const vers = versionsResponse.data.data || [];
            setVersions(vers);
            const contractResponse = await api.getContractById(contract.id);
            // const currentVersionId = contractResponse.data.data?.versionId;
            const currentVersionId = parseInt(id!!);
            const curVer = vers.find((v: any) => v.id === currentVersionId);
            setCurrentVersion(curVer);
            form.setFieldsValue(contract);
        }
        setMode(isVersionId ? Mode.Version : Mode.Detail);
    }

    const doSubmit = async (value: any) => {
        const attachment: UploadFile = value.attachment;
        if (attachment?.originFileObj) {
            const key = utils.generateFileName(`contract/attachments/`, attachment.name);
            value.attachment = await minIoUtils.upload(attachment.originFileObj, key);
        }
        let response
        if (mode === Mode.Create) {
            response = await api.modifyContract(value);
        } else if (mode === Mode.Revision) {
            response = await api.revisionContract(value);
        } else if (mode === Mode.Modify && isVersionId) {
            response = await api.updateVersion(id, value);
        } else if (mode === Mode.Modify && (!isVersionId)) {
            response = await api.modifyContract(value);
        }

        if (mode === Mode.Create) {
            setMode(Mode.Detail);
            history.replace(`/contract/contract/detail/${response?.data.data}`);
        } else if (mode === Mode.Modify) {
            setMode(isVersionId ? Mode.Version : Mode.Detail);
            getData();
            // getVersions(parseInt(id!!)).then(() => getContract(parseInt(id!!)));
        } else if (mode === Mode.Revision) {
            history.replace(`/contract/contract/version/${response?.data.data}`);
            // setMode(Mode.Detail);
            // getData();
            // getVersions(parseInt(id!!)).then(() => getContract(parseInt(id!!)));
        }
    }

    const {loading: loadingExistContract, run: getExistContract} = useRequest(api.getExistContract, {
        manual: true,
        onSuccess(res) {
            setExistContracts(res.data.data);
        }
    });

    const {loading: loadingDelete, run: runDelete} = useRequest(api.deleteContract, {
        manual: true,
        onSuccess(res) {
            message.success('已删除');
            history.replace('/contract/contract')
        }
    })

    const {loading: loadingImportProduct, run: runImportProduct} = useRequest(api.importProduct, {
        manual: true,
        onSuccess(res) {
            handleImportProducts(res.data.data || []);
            setImportProductModalVisible(false);
        }
    });

    const {loading: loadingImportGiveaways, run: runImportGiveaways} = useRequest(api.importGiveaways, {
        manual: true,
        onSuccess(res) {
            handleImportGiveaways(res.data.data || []);
            setImportGiveawaysModalVisible(false);
        }
    });


    const {loading: loadingGetHospitals, run: getHospitals} = useRequest(instrumentApi.getHospitalByDealer, {
        manual: true,
        onSuccess(res) {
            setHospitalOption(res?.data?.data || []);
            if (mode == Mode.Create) {
                form.setFieldValue('hospitalId', []);
            }
        }
    })

    const {loading: loadingToOA, run: runToOA} = useRequest(api.toOA, {
        manual: true,
        throttleWait: 3000,
        throttleTrailing: false,
        onSuccess(res) {
            message.success('已送审');
            getData();
        }
    })
    const {
        loading: loadingGetInstruments,
        run: getInstruments
    } = useRequest(instrumentApi.getInstrumentsByHospitalAndDealer, {
        manual: true,
        onSuccess(res) {
            setInstrumentsOption(res?.data?.data || []);
            if (mode == Mode.Create) {
                form.setFieldValue('instrumentId', null);
            }
        }
    })

    const {loading: loadingProductOptions} = useRequest(productApi.getAllProducts, {
        manual: false,
        onSuccess(res) {
            const result = res.data.data.map((p: any) => {
                p.categoryName = !!p.categoryName ? p.categoryName.replaceAll('//', '/').split('/')?.[1] : undefined;
                return p;
            });
            setProductOptions(res.data.data);
        }
    });
    const {loading: loadingSuitOptions} = useRequest(suitApi.getAllSuits, {
        manual: false,
        onSuccess(res) {
            setSuitOptions(res.data.data);
        }
    })

    const {loading: loadingSuitAppend, runAsync: runSuitAppend} = useRequest(doSuitAppend, {
        manual: true,
    });
    const {loading: loadingGiveawaysAppend, runAsync: runGiveawaysAppend} = useRequest(doGiveawaysAppend, {
        manual: true
    })
    const {loading: loadingGetData, run: runGetData} = useRequest(getData, {
        manual: true,
    });

    const refreshSuitDisabled = () => {
        const existed: Array<any> = (form.getFieldValue('products') || []).map((p: any) => p.suitId);
        const result = suitOptions.map((o: any) => ({...o, disabled: existed.includes(o.id)}));
        setSelectedSuit(undefined);
        setSuitOptions(result);
    }

    const refreshProductDisabled = () => {
        const existed: Array<any> = (form.getFieldValue('products') || []).filter((p: any) => !p.suitId).map((p: any) => p.productId);
        const result = productOptions.map((o: any) => ({...o, disabled: existed.includes(o.id)}));
        setProductOptions(result);
    }

    const handleProductPriceChange = (value: any, record: any, index: number) => {
        if (!record.suitId) return;
        const newProducts = [...(products || [])];
        newProducts[index].price = value;
        const suitProducts = (newProducts || []).map((p: any, index: number) => ({
            ...p,
            index
        })).filter((p: any) => p.suitId === record.suitId);
        const prices = suitProducts.map((p: any) => (p.price ?? 0) * (p.productQty ?? 0)).reduce((p1: number, p2: number) => p1 + p2);
        const result: any = [];
        suitProducts.forEach((p: any) => {
            form.setFieldValue(['products', p.index, 'suitPrice'], prices);
        })
    }


    const handleSubmit = async () => {
        await form.validateFields().then((value: any) => {
            if (dayjs(value.startDate).isAfter(dayjs(value.endDate))) {
                message.error('失效日期必须晚于生效日期')
            } else {
                value.products = products?.filter((p: any) => !!p.productId)
                value.products.forEach((p: any) => {
                    p.restrictQty = (!purchaseRestrict) ? null : p.restrictQty;
                });
                return doSubmit(value);
            }
        }).catch(() => {
            message.error('请填写必填字段');
        })
    }


    const {loading: loadingSubmit, run: runSubmit} = useRequest(handleSubmit, {
        debounceWait: 1000,
        manual: true,
    });

    const handleRemoveSuitProduct = (suitId: number): void => {
        const products = form.getFieldValue('products') || [];
        const result = products.filter((p: any) => p.suitId !== suitId);
        form.setFieldValue('products', result);
        // refreshSuitDisabled();
    }
    const handleRemoveProduct = (index: number, record: any) => {
        form.setFieldValue('products', products?.filter((p: any, i: number) => i != index));
    }

    const handleRemoveAllProducts = () => {
        form.setFieldValue('products', []);
    }

    const handleImportProducts = (records: any[]) => {

        const existProducts = products?.filter(p => !!p.productId) || [];
        const appendProducts = records.filter((rec: any) => !existProducts.some(p => p.productId == rec.productId && (!p.suitId)));
        // 2024-11-04 默认勾选
        appendProducts.forEach((p) => p.enableGiveaway = true);
        //
        form.setFieldValue('products', [...existProducts, ...appendProducts]);
    }

    const handleImportGiveaways = (records: any[]) => {
        (products || []).forEach((p: any, i) => {
            if (!p.suitId) {
                const giveaways = records.filter(rec => rec.productId == p.productId);
                form.setFieldValue(['products', i, 'giveaways'], [...giveaways]);
                form.setFieldValue(['products', i, 'enableGiveaway'], giveaways?.length > 0);
            }
        });
    }

    const handleAddProducts = (ids?: number[], records?: any[]) => {
        const existProducts = products || [];
        const selectProducts = records || [];
        const selectIds = ids || [];
        const errorRecords = existProducts.filter((p: any) => !p.suitId && selectIds.includes(p.productId));
        if (errorRecords.length) {
            errorRecords.forEach(p => message.error(`${p.productName}(${p.productCode})已存在`));
            return;
        }
        const newProducts = selectProducts.map((rec: any) => ({
            productId: rec.id,
            productCode: rec.code,
            productName: rec.name,
            productSpecification: rec.specification,
            productQuote: rec.quote,
            productCategoryName: !!rec.categoryName ? rec.categoryName.replaceAll('//', '/').split('/')?.[1] : undefined,
            expiration: 6,
            giveaways: [],//rec.giveaways?.map((g:any)=>({...g, id:undefined})),
            // enableGiveaway: !!rec.giveaways?.length, // 2024-11-04 改为默认勾选
            enableGiveaway: true
        }));
        setProductModalVisible(false);
        form.setFieldValue('products', [...(products?.filter(p => !!p.productId) || []), ...newProducts]);
    }

    // const handleEnableGiveawayChange = (index: number) => {
    //     const product = form.getFieldValue(['products', index]);
    //     if (product.enableGiveaway) {
    //         runGiveawaysAppend(index);
    //     }else{
    //         form.setFieldValue(['products', index, 'giveaways'], []);
    //     }
    // }

    const handleEnableConsignmentChange = (index: number) => {
        const {suitId, enableConsignment} = form.getFieldValue(['products', index]);
        if (!suitId) {
            return;
        }
        [...products || []].filter(p => p.suitId == suitId).forEach((p: any, i: number) => {
            form.setFieldValue(['products', i, 'enableConsignment'], enableConsignment);
        })

    }

    const handleGiveawaysShow = (index: number) => {
        setGiveawaysNamePath(['products', index]);
        setGiveawaysModalVisible(true);
    }

    const handleOAApprove = () => {
        if (isVersionId) {
            runToOA(id)
            return;
        }
        const ver: any = versions.reverse().find((v: any) => v.status == 0);
        if (!ver) {
            message.error('没有待审核的合同版本');
            return;
        }
        runToOA(ver.id);

    }

    const handleAcceptVersion = () => {
        let operateVersionId = undefined;
        if (isVersionId) {
            operateVersionId = id
        } else {
            const ver: any = versions.reverse().find((v: any) => v.status == 0);
            if (!ver) {
                return;
            }
            operateVersionId = ver.id
        }

        setIsApproving(true)
        api.acceptVersion(operateVersionId).then(() => {
            message.success('操作成功');
            getData();
        }).finally(() => {
            setIsApproving(false)
        });
    }
    const handleRejectVersion = () => {
        let operateVersionId = undefined;
        if (isVersionId) {
            operateVersionId = id
        } else {
            const ver: any = versions.reverse().find((v: any) => v.status == 0);
            if (!ver) {
                return;
            }
            operateVersionId = ver.id
        }

        setIsApproving(true)
        api.rejectVersion(operateVersionId).then(() => {
            message.success('操作成功');
            getData();
        }).finally(() => {
            setIsApproving(false)
        })
    }

    const handleModify = () => {
        if (mode === Mode.Detail) {
            setMode(Mode.Modify)
            //修改版本，覆盖合同
        } else if (mode === Mode.Version) {
            //仅修改版本
            setMode(Mode.Modify)
        }
    }

    const calcDiscount = (index: number) => {
        const product = (products || [])[index];
        const {price = 0, productQuote = 0} = product || {};
        const discount = price / productQuote * 100;
        if (discount === Infinity || isNaN(discount)) {
            return null;
        } else {
            return discount.toFixed(2)
        }

    }

    const columns: Array<ColumnProps<any>> = [
        {
            key: 'operation',
            title: '操作',
            width: 120,
            fixed: "left",
            render(value, record, index) {
                return (<Space>
                    {record.suitId ?
                        <Popconfirm title={'套餐商品移除时，将移除整个套餐，是否确认移除此商品?'}
                                    onConfirm={() => handleRemoveSuitProduct(record.suitId)}><Button>-</Button></Popconfirm> :
                        <Button onClick={() => handleRemoveProduct(index, record)}>-</Button>}
                    <Button onClick={() => setProductModalVisible(true)}>+</Button>
                </Space>)
            }
        },
        {
            key: 'productCode',
            dataIndex: 'productCode',
            title: '商品编码',
            width: 140,
            fixed: 'left'
        },
        {
            key: 'productName',
            dataIndex: 'productName',
            title: '商品名称',
            width: 140,
        },
        // FormValueColumn('productName', '商品名称'),
        FormValueColumn('suitName', '套餐名称'),
        {
            dataIndex: 'suitPrice',
            key: 'suitPrice',
            title: '套餐价格',
            width: 100,
            render(v) {
                return v ? v.toFixed(2) : v
            }
        },
        // FormValueColumn('suitPrice', '套餐价格'),
        // FormValueColumn('productCode', '商品编码'),
        FormValueColumn('productSpecification', '商品型号'),
        FormValueColumn('productCategoryName', '产品线'),
        FormValueColumn('productQty', '套餐规定数量'),
        FormValueColumn('productQuote', '报价'),
        {
            dataIndex: 'price',
            key: 'price',
            title: '销售价',
            render(value, record, index) {
                return <Form.Item name={[index, 'price']}>
                    <InputNumber step={0.01} onChange={(value) => handleProductPriceChange(value, record, index)}/>
                </Form.Item>
            }
        },
        {
            dataIndex: 'discount',
            key: 'discount',
            title: '折扣率(%)',
            render(value, record, index) {
                return (<Form.Item name={[index, 'discount']}>
                    {calcDiscount(index)}
                </Form.Item>)
            }
        },
        {
            dataIndex: 'restrictQty',
            key: 'restrictQty',
            title: '限购数量',
            width: 100,
            render(value, record, index) {
                return <Form.Item name={[index, 'restrictQty']}>
                    {!!record.suitId || (!purchaseRestrict) ? <div/> : <InputNumber step={1} precision={0}/>}
                </Form.Item>
            }
        },
        {
            dataIndex: 'remainQty',
            key: 'remainQty',
            title: '剩余数量',
            width: 100,
            render(value, record, index) {
                const result = record.restrictQty == null ? null : (record.restrictQty - (record.consumeQty || 0));
                return (<Tooltip title="剩余数量=限购数量-已用数量">
                    <div>{typeof result == 'number' && result < 0 ? 0 : result}</div>
                </Tooltip>)

            }
        },
        {
            dataIndex: 'expiration',
            key: 'expiration',
            title: '有效期(月)',
            render(value, record, index) {
                return (<Form.Item name={[index, 'expiration']} initialValue={6}>
                    <InputNumber step={1}/>
                </Form.Item>)
            }
        },
        {
            dataIndex: 'enableConsignment',
            key: 'enableConsignment',
            title: <Tooltip title={'选中的商品方能使用寄售业务'} autoAdjustOverflow trigger={'hover'}>
                <p>寄售业务<QuestionCircleOutlined style={{color: 'var(--danger-color)'}}/></p></Tooltip>,
            render(value, record, index) {
                return <Form.Item name={[index, 'enableConsignment']} valuePropName={'checked'} initialValue={false}>
                    <Checkbox onChange={() => handleEnableConsignmentChange(index)}/>
                </Form.Item>
            }
        },
        {
            dataIndex: 'enableGiveaway',
            key: 'enableGiveaway',
            title: '是否赠送',
            render(value, record, index) {
                return <Form.Item name={[index, 'enableGiveaway']} valuePropName={'checked'}>
                    <Checkbox/>
                </Form.Item>
            }
        },
        {
            dataIndex: 'giveaways',
            key: 'giveaways',
            title: '满赠规则',
            render(value, record, index) {
                const product = form.getFieldValue(['products', index]);
                return <Form.Item>
                    {product?.enableGiveaway && <a onClick={() => handleGiveawaysShow(index)}>详情</a>}
                </Form.Item>
            }
        }
    ];
    const versionColumns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'updateName',
            key: 'updateName',
            title: '变更人',
        },
        {
            dataIndex: 'updateTime',
            key: 'updateTime',
            title: '变更时间',
            render(v) {
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'code',
            key: 'code',
            title: '变更编码'
        },
        {
            dataIndex: 'description',
            key: 'description',
            title: '变更说明'
        },
        // {
        //     dataIndex: 'approveBy',
        //     key: 'approveBy',
        //     title: '审核人'
        // },
        {
            dataIndex: 'approveDate',
            key: 'approveDate',
            title: '审核日期',
            render(v: any) {
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'approveCode',
            key: 'approveCode',
            title: '审核编号'
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: '审核状态',
            render(v: any) {
                return ContractStatusMapping[v] || v;
            }
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(_: any, r: any) {
                return (<Space>
                    <Link to={`/contract/contract/version/${r.id}`}>详情</Link>
                </Space>)
            }
        }
    ];

    const handleExistContractsClick = () => {
        setExistContractsModalVisible(true);
    }

    const existContractTip: TooltipProps = {
        defaultOpen: true,
        title: (<p>存在未提交、审核中、和生效合同，<a onClick={handleExistContractsClick}>点击查看</a></p>)
    }

    const toolbar = (
        <div className={styles.Toolbar}>
            {currentVersion ? <Space className={styles.CurrentVersionInfo}>
                <span>版本：{currentVersion.code}</span>
                <span>制单人：{currentVersion.createName}</span>
                <span>制单日期：{currentVersion.createTime && dayjs(currentVersion.createTime).format('ll')}</span>
                <span>审核日期：{currentVersion.approveDate && dayjs(currentVersion.approveDate).format('ll')}</span>
                <span>状态：{
                    (dayjs(Date.now()).isBefore(form.getFieldValue('startDate'), 'day') || dayjs(Date.now()).isAfter(form.getFieldValue('endDate'), 'day')) ?
                        '失效' :
                        (ContractStatusMapping[currentVersion.status as number] || '') as string
                }</span>
            </Space> : <Space>&nbsp;</Space>}
            <Space>
                {((mode === Mode.Detail && versions.some((v: any) => v.status == 0)) || (mode === Mode.Version && currentVersion.status == 0)) &&
                    <ToOAButton onClick={handleOAApprove} type={'link'} loading={loadingToOA}>OA送审</ToOAButton>}
                {((mode === Mode.Detail && versions.some((v: any) => v.status == 0)) || (mode === Mode.Version && currentVersion.status == 0)) &&
                    <AcceptFragment><Button type={'link'} onClick={handleAcceptVersion}
                                            loading={isApproving}>终审通过</Button></AcceptFragment>}
                {((mode === Mode.Detail && versions.some((v: any) => v.status == 0)) || (mode === Mode.Version && currentVersion.status == 0)) &&
                    <RejectFragment><Button type={'link'} onClick={handleRejectVersion}
                                            loading={isApproving}>终审拒绝</Button></RejectFragment>}
                {((mode === Mode.Detail && currentVersion.status == 0) || (mode == Mode.Version && (currentVersion.status == 0 || currentVersion.status == 3))) &&
                    <EditButton type={'link'} loading={loadingSubmit} onClick={handleModify}>修改</EditButton>}
                {mode === Mode.Detail && !versions.some((v: any) => v.status == 0 || v.status == 2 || (v.status == 3 && versions.length == 1)) &&
                    <RevisionButton type={'link'} loading={loadingSubmit}><a
                        onClick={() => setMode(Mode.Revision)}>变更</a></RevisionButton>}
                {/*{mode === Mode.Detail && !versions.some((v:any)=>v.status==0||v.status==2)  && <DeletePopconfirm title={'是否确认删除合同？'} onConfirm={()=>runDelete(id)}><Button type={'link'} loading={loadingDelete}>删除</Button></DeletePopconfirm> }*/}
                {<Button type={'link'} onClick={() => history.goBack()}>返回</Button>}
            </Space>
        </div>
    );
    const versionList = (
        mode === Mode.Detail && <Row>
            <Col span={24}>
                <h3 className={styles.SectionTitle}>历史版本</h3>
            </Col>
            <Col span={24}>
                <Table columns={versionColumns} dataSource={versions} pagination={false}/>
            </Col>
        </Row>
    );

    return <PageHeaderLayout withFooterBar={mode != Mode.Detail && mode !== Mode.Version} onOk={runSubmit}
                             onCancel={() => history.goBack()} btnLoading={loadingSubmit}>
        <Card title={toolbar}>
            <Form form={form} labelCol={{sm: 6}} disabled={forceDisabled}>
                <Form.Item noStyle name={'id'}/>
                {(mode === Mode.Version || mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && <>
                    <h3 className={styles.SectionTitle}>变更说明</h3>
                    <Row>
                        <Col span={24}>
                            <Form.Item name={'type'} label={'变更类型'} labelCol={{xs: 2}} rules={[{required: true}]}>
                                <DictSelect dict={'ContractRevision'} appendNull={false}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item name={'description'} label={'变更说明'} labelCol={{xs: 2}}
                                       rules={[{required: true}]}>
                                <Input.TextArea rows={3}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </>}
                <h3 className={styles.SectionTitle}>基本信息</h3>
                <Row gutter={12}>
                    <Col span={8}>
                        <Form.Item name={'code'} label={'合同编号'}>
                            <Input disabled placeholder={'自动生成'}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'contractType'} label={'客户类型'} rules={[{required: true}]}>
                            <DictSelect dict={'ContractType'} appendNull={false}
                                        disabled={forceDisabled || mode === Mode.Modify || mode === Mode.Revision}/>
                        </Form.Item>
                    </Col>
                    {contractType == 'group-contract' && <Col span={8}>
                        <Form.Item name={'groupId'} label={'集团'} rules={[{required: true}]}
                                   tooltip={(existContracts?.length && mode == Mode.Create) ? existContractTip : undefined}>
                            <BaseDataSelect name={'groups'}
                                            disabled={forceDisabled || mode === Mode.Modify || mode === Mode.Revision}/>
                        </Form.Item>
                    </Col>}
                    {contractType == 'dealer-contract' &&
                        <Col span={8}>
                            <Form.Item name={'dealerId'} label={'客户'} rules={[{required: true}]}
                                       tooltip={(existContracts?.length && mode == Mode.Create) ? existContractTip : undefined}>
                                <Select url={dealerApi.getDealerList} getData={data => data.data} textField={'name'}
                                        onChangeWithOption={(v, o: any) => {
                                            o?.currency && form.setFieldValue('currency', o.currency);
                                        }}
                                        disabled={forceDisabled || mode === Mode.Modify || mode === Mode.Revision}/>
                            </Form.Item>
                        </Col>}
                    {contractType == 'dealer-contract' &&
                        <Col span={8}>
                            <Form.Item name={'isTerminal'} label={'是否终端'} valuePropName={'checked'}>
                                <Switch disabled={forceDisabled || mode === Mode.Revision}/>
                            </Form.Item>
                        </Col>}
                    {
                        contractType == 'dealer-contract' && isTerminal &&
                        <>
                            <Col span={8}>
                                <Form.Item name={'hospitalId'} label={'终端医院'} rules={[{required: true}]}>
                                    {/*<Select url={hospitalApi.getHospital} getData={data => data.data}*/}
                                    {/*        textField={'name'} disabled={forceDisabled||mode===Mode.Revision}/>*/}
                                    <AntSelect options={hospitalsOption}
                                               fieldNames={{value: 'hospitalId', label: 'hospitalName'}}
                                               disabled={forceDisabled || mode === Mode.Revision}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'instrumentId'} label={'仪器型号'} rules={[{required: true}]}>
                                    <AntSelect options={instrumentsOption}
                                               fieldNames={{value: 'id', label: 'specificationAndModel'}}
                                               disabled={forceDisabled || mode === Mode.Revision}/>
                                </Form.Item>
                            </Col>
                        </>
                    }
                    <Col span={8}>
                        <Form.Item name={'currency'} label={'币种'} initialValue={'CNY'} rules={[{required: true}]}>
                            {/*<AntSelect options={[{value: 'CNY', label: 'CNY'}]} disabled={forceDisabled||mode===Mode.Revision}/>*/}
                            <BaseDataSelect name={'currencies'} appendNull={false}
                                            disabled={forceDisabled || mode === Mode.Revision}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoiceGiveaway'} label={'赠品是否开票'} valuePropName={'checked'}>
                            <Switch
                                disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('invoiceGiveaway'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'paymentForm'} label={'付款形式'} rules={[{required: true}]}>
                            <DictSelect dict={'PaymentForm'} appendNull={false}
                                        disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('paymentForm'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'startDate'} label={'生效日期'} rules={[{required: true}]}
                                   initialValue={dayjs(Date.now())}>
                            <DatePicker picker={'date'}
                                        disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('startDate'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'endDate'} label={'失效日期'}
                                   rules={[{required: true, message: '请输入失效日期'}]}
                            /*initialValue={dayjs('2099-12-31')}*/>
                            <DatePicker picker={'date'}
                                        disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('endDate'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'sampleRule'} label={'样品规则'} rules={[{required: true}]}>
                            <Radio.Group disabled={forceDisabled || mode === Mode.Revision}>
                                <Radio value={'ratio'}>校准和质控固定比例</Radio>
                                <Radio value={'quota'}>样品额度</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'purchaseRestrict'} label={'商品限购规则'}>
                            <DictSelect dict={'PurchaseRestrict'} appendNull/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'contractCategory'} label={'合同类型'}>
                            <DictSelect dict={'ContractCategory'}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'signingAmount'} label={'签约总额'} rules={[{required: true}]}>
                            <InputNumber step={0.01} style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    {/*<Col span={8}>*/}
                    {/*    <Form.Item name={'synYunyigou'} label={'同步云医购'} valuePropName={'checked'}>*/}
                    {/*        <Switch/>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                    <Col span={24}>
                        <Form.Item name={'remark'} label={'合同备注'} labelCol={{xs: 2}}>
                            <Input.TextArea rows={3}
                                            disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('remark'))}/>
                        </Form.Item>
                    </Col>
                </Row>
                <h3 className={styles.SectionTitle}>快递政策</h3>
                <Row>
                    <Col span={8}>
                        <Form.Item name={'transportMethod'} label={'运输方式'} rules={[{required: true}]}>
                            <BaseDataSelect name={'expresses'} defaultSelectFirst
                                            disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('transportMethod'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'transportFreeTimes'} label={'免费次数'} rules={[{required: true}]}
                                   initialValue={2}>
                            <InputNumber step={1} addonAfter={'次'}
                                         disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('transportFreeTimes'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'transportFullCredit'} label={'满减额度'} rules={[{required: true}]}
                                   initialValue={3}>
                            <InputNumber step={0.01} addonAfter={'万元'}
                                         disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('transportFullCredit'))}/>
                        </Form.Item>
                    </Col>
                </Row>
                <h3 className={styles.SectionTitle}>附件<h6
                    className={styles.SectionSubTitle}>（附件最大20M，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF、RAR、ZIP）</h6>
                </h3>
                <Row>
                    <Col span={8}>
                        <Form.Item name={'attachment'}
                                   rules={[{validator: Upload.validator({limit: 20 * 1024 * 1024})}]}
                                   validateTrigger={'onChange'}>
                            <Upload maxCount={1}
                                    disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('attachment'))}/>
                        </Form.Item>
                    </Col>
                </Row>
                <h3 className={styles.SectionTitle}>商品列表</h3>
                <Row>
                    <Col span={12}>
                        <Form.Item label={'套餐'} labelCol={{span: 1}}>
                            <AntSelect options={suitOptions} fieldNames={{label: 'name', value: 'id'}}
                                       value={selectedSuit}
                                       showSearch
                                       loading={loadingSuitOptions}
                                       optionFilterProp={'options'}
                                       filterOption={(input, option) => option?.name?.includes(input)}
                                       disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('suit'))}
                                       onChange={(v) => setSelectedSuit(v)}/>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <span>&nbsp;&nbsp;&nbsp;</span>
                        <Button type={"primary"} loading={loadingSuitAppend} onClick={runSuitAppend}
                                disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('suit'))}>添加</Button>
                    </Col>
                    <Col span={6} style={{textAlign: "right"}}>
                        {(mode == Mode.Modify || mode == Mode.Revision || mode == Mode.Create) && <Space>
                            <Popconfirm title={"是否确定删除所有商品？"} onConfirm={handleRemoveAllProducts}><Button
                                type={"primary"} danger
                                disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('products'))}>批量删除</Button></Popconfirm>
                            <ImportProductButton type={"primary"} onClick={() => setImportProductModalVisible(true)}
                                                 disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('products'))}>导入商品</ImportProductButton>
                            <ImportGiveawaysButton type={"primary"} onClick={() => setImportGiveawaysModalVisible(true)}
                                                   disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('products'))}>导入赠品</ImportGiveawaysButton>
                        </Space>}
                    </Col>
                </Row>
            </Form>
            <Form form={form} labelCol={{sm: 6}}
                  disabled={forceDisabled || ((mode === Mode.Revision || (mode === Mode.Modify && isVersionId)) && !revisionEnableFields.includes('products'))}>
                <Form.List name={'products'}>
                    {
                        (fields, {add, remove}) =>
                            <Table columns={columns}
                                   sticky
                                   scroll={{x: 'max-content'}}
                                   className={styles.ProductTable}
                                   pagination={false}
                                   dataSource={products?.length ? form.getFieldValue('products') : [{}]}/>
                    }
                </Form.List>
            </Form>
            {versionList}
        </Card>
        <ProductSelectModal multiple open={productModalVisible} onComplete={handleAddProducts}
                            url={'/product/withGiveaways'}
                            onCancel={() => setProductModalVisible(false)} key={'product-select'}/>
        <GiveawayRulesModal form={form} enableModify={mode !== Mode.Detail && mode !== Mode.Version}
                            open={giveawaysModalVisible}
                            prefixNamePath={giveawaysNamePath}
                            onCancel={() => setGiveawaysModalVisible(false)}
                            permissionEnable={enableModifyGiveaways}
                            onOk={() => setGiveawaysModalVisible(false)}/>
        <ExistContractsModal open={existContractsModalVisible} onCancel={() => setExistContractsModalVisible(false)}
                             records={existContracts}/>

        <UploadModal key={'importGiveaways'}
                     title={'导入赠品'}
                     open={importGiveawaysModalVisible}
                     confirmLoading={loadingImportGiveaways}
                     onUpload={runImportGiveaways}
                     onCancel={() => setImportGiveawaysModalVisible(false)}
                     template={'/template/赠品列表导入模板.xlsx'}/>
        <UploadModal key={'importProduct'}
                     title={'导入商品'}
                     open={importProductModalVisible}
                     confirmLoading={loadingImportProduct}
                     onUpload={runImportProduct}
                     onCancel={() => setImportProductModalVisible(false)}
                     template={'/template/合同内明细批量新增模板.xlsx'}/>
    </PageHeaderLayout>
}

export default ContractEdit;
